import { connect } from 'react-redux'
import { actions, BulkWrapper } from '@opallabs/wormhole'
import { PlacementCreator } from '.'

const mapStateToProps = (state, props) => {
  const appState = new BulkWrapper(state)
  let placements = []

  if (appState.placement) {
    placements = appState.placement.filter(
      (p) => p.relationships?.account?.id === props.accountId
    )
    placements.sort((a, b) => a.position - b.position)
  }

  return { placements }
}

const mapDispatchToProps = (dispatch) => ({
  createPlacement: (options) => dispatch(actions.createPlacement(options)),
  destroyPlacement: (options) => dispatch(actions.destroyPlacement(options)),
  getPlacements: (options) => dispatch(actions.getPlacements(options)),
  updatePlacement: (options) => dispatch(actions.updatePlacement(options)),
})

const ConnectedPlacementCreator = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlacementCreator)

export default ConnectedPlacementCreator
